import styled from 'styled-components/native';

const HEIGHT = 1;

export default styled.View`
  width: 100%;
  height: ${HEIGHT}px;
  background-color: ${(props) => props.theme.COLORS.PRIMARY_BACKGROUND};
`;
